import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {
    Table,
    SearchButton,
    LightTextButton,
    FilterDropdown,
    SwitchButton,
    ImageStamp,
    TextLink,
    TextInput,
    Status,
    Search
} from "components";
import {customersAction, lifestyleMembershipAction} from "redux/actions";
import PackagesPopup from "../popups/Packages/PackagesPopup";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";
import MemberProfileDetailsModal from "../../Report/MemberProfileDetailsModal";
import {adminToken} from "../../../helper";
import axios from "axios";
import {AWS_URL_UM_INT_8089} from "../../../configurations";
// import MemberProfileDetailsModal from "../modals/MemberProfileDetailsModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
import UpdateGrandAPPSeniorModel from "../modals/UpdateGrandAPPSeniorModel";

const initialState = {
    id: "",
    user_id: "",
    discount_code: "",
    expiry_date: "",
    membership_type: ""
};

export default function LifestyleMembershipPanel() {
    // Routers
    const {push, location} = useHistory();

    const [openModal, setOpenModal] = useState(false)
    const [refreshPage, setRefreshPage] = useState(null)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openCusModal, setOpenCusModal] = useState(false)

    const handleCloseCusModal = () => {
        setOpenCusModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [clickedCustomer, setClickedCustomer] = useState(null)
    const [clickedElder, setClickedElder] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [openModalUpdateSenior, setOpenModalUpdateSenior] = useState(false);

    const handleOpenModalUS = () => {
        setOpenModalUpdateSenior(true)
    }
    const handleCloseUS = () => {
        setOpenModalUpdateSenior(false)
    }

    // Query based filter
    const locationSearch = useLocation().search;
    const query = new URLSearchParams(locationSearch);
    const userID = 1;//query.get("userID");

    // States
    const [tableRows, setTableRows] = useState();
    const [exportdata, setExportdata] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();

    // const [filterState, setFilterState] = useState(false)

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState(initialState);
    const [activeStatus, setActiveStatus] = useState(11);
    const [currentElderID, setCurrentElderID] = useState(11);
    

    // Redux actions
    const dispatch = useDispatch();
    const {customers, lifestylemembership, userRole} = useSelector(state => ({
        customers: state.customers,
        lifestylemembership: state.lifestyleMembership,
        userRole: state.userRole?.filter(role => role.module === "Lifestyle Membership")
    }));


    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(lifestyleMembershipAction.get());
            // dispatch(customersAction.get(1));
        return () => dispatch(lifestyleMembershipAction.reset());
    }, [activeStatus]);

    // const onPageChange = e => dispatch(customersAction.get(e));
    const onPageChange = e => dispatch();

    const handleOpenCusModal = (fname) => {
        console.log(JSON.stringify(filterState));
        dispatch(
            customersAction.search({
                pageNumber: 1,
                query: fname
            })
        )
        setOpenCusModal(true)
    }

    const onChange = e => setfilterState({...filterState, [e.target.name]: e.target.value});

    // internal search
    const internalSearch = (searchBy, rows) => {
        // if (!filterState?.[searchBy]) return rows;

        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item[searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    // internal search for user details sub arrsy
    const internalSearchUser = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;
        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item['get_user'][searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    const handleUpdateStatus = async (userId) => {
        // let result = window.confirm('Are you sure?');
        // if(result){
        //     await dispatch(customersAction.updateElderEnabledStatus(userId));
        //     setTimeout(() => {
        //         setActiveStatus(Math.floor(Math.random() * 100));
        //     },1000)
        // }        
    };

    useEffect(() => {
        if (!lifestylemembership?.length) {
            setTableRows();
            return;
        }

        let filtered = lifestylemembership;
        
        if (userRole?.find(item => item.privilege === "Read")){
            filtered = internalSearch("id", filtered);
            filtered = internalSearch("user_id", filtered);
            filtered = internalSearch("membership_type", filtered);
            filtered = internalSearch("discount_code", filtered);
            filtered = internalSearch("expiry_date", filtered);
        }
        setExportdata(filtered);

        // if (userID) {
        //     filtered = filtered?.filter(user => user.userId == userID);
        // }

        // // filter based on Status
        // filtered = filtered?.filter(item =>
        //     status === "Enabled"
        //         ? item.enabled
        //         : status === "Disabled"
        //             ? !item.enabled
        //             : item
        // );
        // if (userRole?.find(item => item.privilege === "Read")){
        //     filtered = internalSearch("userId", filtered);
        //     filtered = internalSearch("firstName", filtered);
        //     filtered = internalSearch("lastName", filtered);
        //     filtered = internalSearch("mobile", filtered);
        // }

        let newData = [];
        // const printContryName = (contrycode) => {
        //     return (contrycode == '+91')?'India':contrycode;
        // }
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                id: obj?.id,
                userId: (
                    <TextLink
                        text={obj?.get_user?.id}
                        onClick={() => {
                            // push(`${location.pathname}/${obj?.userId}`)
                            setClickedCustomer({id: obj?.get_user?.id, mobile: obj?.get_user?.mobile, name: obj?.get_user?.first_name + " " + obj?.get_user?.last_name})
                            handleOpenCusModal(obj?.get_user?.first_name)
                        }}
                    />
                ),
                membership_type: obj?.membership_type,
                discount_percent: obj?.discount_percent,
                discount_code: obj?.discount_code,
                effective_date: `${new Date(obj?.effective_date).toISOString().split("T")[0]}`,
                expiry_date: (
                    <div
                    dangerouslySetInnerHTML={{
                        __html: (new Date(obj?.expiry_date) < new Date())
                        ? `<span style="color:red;">${new Date(obj?.expiry_date).toISOString().split("T")[0]}</span>`
                        : new Date(obj?.expiry_date).toISOString().split("T")[0]
                    }}
                    />
                ),
                renewal_date: (
                    <div
                    dangerouslySetInnerHTML={{
                        __html: (new Date(obj?.renewal_date) < new Date())
                        ? `<span style="color:red;">${new Date(obj?.renewal_date).toISOString().split("T")[0]}</span>`
                        : new Date(obj?.renewal_date).toISOString().split("T")[0]
                    }}
                    />
                ),
                createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
                updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`,
                enabled: <a href="javascript:void(0);" onClick={
                        userRole?.find(item => item.privilege != "Enable")
                            ? () => {handleUpdateStatus(obj?.get_user?.id);}
                            : null
                    }><Status active={obj?.get_user?.membership_enabled}/></a>
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [lifestylemembership, status, filterState]);

    // Search based on category & sub category name
    const onSearch = () => {
    };

    // internal search
    // const internalSearch = (searchBy, rows) => {
    //     if (!filterState?.[searchBy]) return rows;

    //     const filteredRows =
    //         rows?.length &&
    //         rows.filter(
    //             item =>
    //                 item[searchBy]
    //                     ?.toString()
    //                     .toLowerCase()
    //                     .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
    //         );

    //     return filteredRows;
    // };

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Member",
                sortBy: "member_id"
            },
            {
                title: "Customer",
                sortBy: "userId"
            },
            {
                title: "Type"
            },
            {
                title: "Discount Percent"
            },
            {
                title: "Discount Code"
            },
            {
                title: "Effective Date"
            },
            {
                title: "Expiry Date"
            },
            {
                title: "Renewal Date"
            },
            {
                title: "Created",
                sortBy: "createdAt"
            },
            {
                title: "Updated",
                sortBy: "updatedAt"
            },
            {
                title: "Enabled"
            },
            // {
            //     title: "Action"
            // }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        const rows = exportdata.map(item => {
            return {
                "Member": item.id,
                "Customer": item.get_user?.id,
                "Type": item.membership_type,
                "Discount Percent": item.discount_percent,
                "Discount Code": item.discount_code,
                "Effective Date": item.effective_date,
                "Expiry Date": item.expiry_date,
                "Renewal Date": item.renewal_date,
                "Created": item.created_at,
                "Updated": item.updated_at,
                "Enabled": item.get_user?.membership_enabled
            }
        })

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, "Lifestyle_membership_data.xlsx");
    }

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Member"
                    name="id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.id}
                />

                <TextInput
                    label="Customer"
                    name="user_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.user_id}
                />
                <TextInput
                    label="Type"
                    name="membership_type"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.membership_type}
                />

                <TextInput
                    label="Discount Code"
                    name="discount_code"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.discount_code}
                />

                <TextInput
                    label="Expiry Date"
                    name="expiry_date"
                    type="date"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.expiry_date}
                />

                <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={exportDataFunc}
                >Export Data
                </button>

                {/*<LightTextButton onClick={() => setfilterState(initialState)}/>*/}
            </div>
            
            {/* totalPage: Math.ceil(customers?.count / 10) */}

            <Table
                headers={tableHeaders}
                data={tableRows}
                current={lifestylemembership?.pageNumber}
                totalPage={0}
                // onPageChange={onPageChange}
                state={filterState !== initialState}
                length={tableRows?.length}
                r_length={lifestylemembership?.users?.length}
                t_length={lifestylemembership?.count}
                exportData={false}
                // exportDataFunc={exportDataFunc}
            />

            {isPopupVisible && (
                <PackagesPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <MemberProfileDetailsModal clickedElder={clickedElder} handleCloseModal={handleCloseModal}
                             setClickedSubscription={setClickedSubscription}
                             handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <MemberProfileDetailsModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openCusModal}
                onClose={handleCloseCusModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <ReportModal clickedCustomer={clickedCustomer} handleCloseModal={handleCloseCusModal}
                             setClickedSubscription={setClickedSubscription}
                             handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>
            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openModalUpdateSenior}
                onClose={handleCloseUS}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <UpdateGrandAPPSeniorModel tableRows={''} handleCloseUS={handleCloseUS} currentElderID={currentElderID} setRefreshPage={setRefreshPage}/>
            </Modal>

        </div>
    );
}
